import React from 'react';
import ReactDOM from 'react-dom';
import Control from './Control';
import Input from '../elements/Input';

import './SugControl.css';

import { dot } from '../../lib/obj';

class SugControl extends Control {

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      focused: false,
    };
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(event.target)) {
      this.setState({focused: false});
    }
  }

  onChange(value) {
    this.setState({value:value});
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }

  onFocus(evt) {
    this.setState({focused:true});
  }

  onBlur(evt) {
    setTimeout(()=>{
      this.setState({focused:false});
    },250)
  }

  onOptionClick(option, index) {
    let value = option.name || option;
    this.setState({value:value, filter:value});
    if (this.props.onChange) {
      this.props.onChange(value, option);
    }
    if (this.props.onOptionClick) {
      this.props.onOptionClick(option, index);
    }
    this.setState({focused:!this.state.focused});
  }

  render() {

    // Handle to the options
    let options = this.state.options || this.props.options || [{name:"foo"},{name:"bar"}];
    let filter = this.state.filter === undefined ? this.props.value : this.state.filter;

    let value = this.state.value;
    let filled = value ? value.length > 0 : false;

    // Show options to suggest
    if (this.props.onSuggest) {
      options = this.props.onSuggest(options, value);
    }

    let className = this.props.className || "";
    return (
      <div className={`SugControl ${className}`} ref="root"
        data-focused={this.state.focused && options.length > 0}
        data-layout={this.props.layout}
        data-theme={this.props.theme}
        data-filled={filled}
        data-error={this.props.error}>
        <Input className="Field" label={this.props.label} value={value} error={this.props.error} onChange={(value)=>this.onChange(value)} onFocus={(e)=>this.onFocus(e)} onBlur={(e)=>this.onBlur(e)} clearable="true"/>
        <div className="Options">
          {options.map((option, index)=>{
            let entry = this.props.onRenderEntry ? this.props.onRenderEntry(option,index) : (option.name || option);
            return (<div className="Option" key={`option${index}`} onClick={()=>{this.onOptionClick(option,index)}}>
              <span className="Entry">{entry}</span>
            </div>);
          })}
        </div>
      </div>
    );
  }
}



export default SugControl
